import React, {
  Children,
  ReactElement,
  cloneElement,
  isValidElement,
  useState,
} from "react";

import { MoreVert } from "@mui/icons-material";
import { IconButton, Menu } from "@mui/material";

interface ClickableElementProps extends React.DOMAttributes<HTMLElement> {
  onClick: () => void;
}

/** Null and friends so a caller can leave an item out conditionally. */
type KebabMenuChild =
  ReactElement<ClickableElementProps> | null | false | undefined;

interface KebabMenuProps {
  children: KebabMenuChild | KebabMenuChild[];
}

const KebabMenu = ({ children }: KebabMenuProps) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        title="Menu options"
        onClick={(e) => setMenuAnchorEl(e.currentTarget)}
      >
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={() => setMenuAnchorEl(null)}
      >
        {Children.map(children, (child) => {
          if (!isValidElement(child)) {
            return child;
          }
          return cloneElement(child, {
            onClick: () => {
              child.props.onClick?.();
              setMenuAnchorEl(null);
            },
          });
        })}
      </Menu>
    </>
  );
};

export default KebabMenu;
